"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MuiListDropdown = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _MuiListExpansion = _interopRequireDefault(require("./components/MuiListExpansion/MuiListExpansion"));

var _MuiList = _interopRequireDefault(require("../MuiList/MuiList"));

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _customProps = require("../../utils/customProps");

var _customComponents = require("../../utils/customComponents");

var MuiListDropdown = function MuiListDropdown(_ref) {
  var rootClass = _ref.rootClass,
      listExpansion = _ref.listExpansion,
      content = _ref.content;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var handleClick = function handleClick() {
    setOpen(!open);
  };

  return /*#__PURE__*/_react.default.createElement(_core.List, {
    className: styles.root
  }, /*#__PURE__*/_react.default.createElement(_MuiListExpansion.default, (0, _extends2.default)({}, listExpansion[0], {
    handleClick: handleClick,
    open: open
  })), /*#__PURE__*/_react.default.createElement(_core.Collapse, {
    in: open,
    timeout: "auto",
    unmountOnExit: true
  }, content.map(function (component, key) {
    return (0, _customComponents.renderComponents)({
      MuiList: _MuiList.default
    }, component, key);
  })));
};

exports.MuiListDropdown = MuiListDropdown;
var _default = MuiListDropdown;
exports.default = _default;
MuiListDropdown.propTypes = {
  /**
   * storyblok multiselect of css classes
   * Override or extend the styles applied to the component
   * */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * components:
   * MuiListItem
   */
  content: function content(props, propName, componentName) {
    var components = ['MuiList'];
    return (0, _customProps.validComponents)(props, propName, componentName, components);
  },

  /**
   * components:
   * MuiListItem
   */
  listExpansion: function listExpansion(props, propName, componentName) {
    var components = ['MuiListItem'];
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, components, 1);
  }
};
MuiListDropdown.defaultProps = {
  rootClass: [],
  content: [],
  listExpansion: []
};